import { getRequest, postRequest, deleteRequest } from "app/axiosClient";
import OpenNotificationWithIcon from "../../../common/utils/OpenNotificationWithIcon";
import {
  getCustomerListRecords,
  getCustomerLocationRecords,
  setLocationSearchCache,
  // getServiceContractRecords, // TODO: re-enable service contract
  getProjectRecords,
  getDefaultProjectRecords,
  getServiceItemRecords,
  showModalLoader,
  hideModalLoader,
} from "../AddAppointment/CreateAppointmentSlice";
import {
  getAppointListAPI,
  setPageNo,
  setSelectedAppointment,
  resetAppointmentstate,
  setRange,
} from "../AppointmentList/AppointmentsAPI";
import dayjs from "dayjs";
export const getAllCustomerListApi = () => (dispatch) => {
  try {
    dispatch(showModalLoader());
    getRequest(`api/Lookup/GetCustomersList`)
      .then((res) => {
        dispatch(getCustomerListRecords(res.data));
        dispatch(hideModalLoader());
      })
      .catch((e) => {
        dispatch(hideModalLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "CreateAppointment.RequestError",
        );
      });
  } catch (e) {
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "CreateAppointment.NoComments",
    );
    dispatch(hideModalLoader());
  }
};

export const getAllCustomerLocationListApi =
  (searchTerm = "") =>
  (dispatch, getState) => {
    try {
      dispatch(showModalLoader());

      // Check Redux cache first
      const cache = getState().CreateAppointment?.locationSearchCache || {};
      const cacheKey = searchTerm.trim().toLowerCase();
      if (cache[cacheKey]) {
        dispatch(getCustomerLocationRecords(cache[cacheKey]));
        dispatch(hideModalLoader());
        return;
      }

      const queryParam = searchTerm
        ? `?searchTerm=${encodeURIComponent(searchTerm)}&top=10`
        : "?top=10";
      getRequest(`api/Lookup/GetCustomersLocationsList${queryParam}`)
        .then((res) => {
          dispatch(
            setLocationSearchCache({ term: cacheKey, results: res.data }),
          );
          dispatch(hideModalLoader());
        })
        .catch((e) => {
          dispatch(hideModalLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "CreateAppointment.RequestError",
          );
        });
    } catch (e) {
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "CreateAppointment.NoComments",
      );
      dispatch(hideModalLoader());
    }
  };

// TODO: re-enable service contract
// export const getServiceContractsByCustomerApi = (customerId) => (dispatch) => {
//   try {
//     dispatch(showModalLoader());
//     getRequest(
//       `api/Lookup/GetServiceContractsByCustomer?customerId=${encodeURIComponent(customerId)}`,
//     )
//       .then((res) => {
//         dispatch(getServiceContractRecords(res.data));
//         dispatch(hideModalLoader());
//       })
//       .catch((e) => {
//         dispatch(hideModalLoader());
//       });
//   } catch (e) {
//     dispatch(hideModalLoader());
//   }
// };

export const getCustomerProjectsListApi = (value) => (dispatch) => {
  try {
    dispatch(showModalLoader());
    getRequest(`api/Lookup/GetProjectsList?CustomerID=${value}`)
      .then((res) => {
        dispatch(getProjectRecords(res.data));
        dispatch(hideModalLoader());
      })
      .catch((e) => {
        dispatch(hideModalLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "CreateAppointment.RequestError",
        );
      });
  } catch (e) {
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "CreateAppointment.NoComments",
    );
    dispatch(hideModalLoader());
  }
};

export const getCustomerDefaultProjectRecords = (value) => (dispatch) => {
  try {
    dispatch(showModalLoader());
    getRequest(`api/Lookup/GetProjectTaskList?projectID=${value}`)
      .then((res) => {
        dispatch(getDefaultProjectRecords(res.data));
        dispatch(hideModalLoader());
      })
      .catch((e) => {
        dispatch(hideModalLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "CreateAppointment.RequestError",
        );
      });
  } catch (e) {
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "CreateAppointment.NoComments",
    );
    dispatch(hideModalLoader());
  }
};

export const getNonStockItemRecordsApi = (value) => (dispatch) => {
  try {
    dispatch(showModalLoader());
    getRequest(`api/Lookup/GetServiceItemsList?ItemType=${value}`)
      .then((res) => {
        dispatch(getServiceItemRecords(res.data));
        dispatch(hideModalLoader());
      })
      .catch((e) => {
        dispatch(hideModalLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "CreateAppointment.RequestError",
        );
      });
  } catch (e) {
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "CreateAppointment.NoComments",
    );
    dispatch(hideModalLoader());
  }
};

export const addNewAppointmentAPI = (payload, refreshURL) => (dispatch) => {
  try {
    const data = payload;
    dispatch(showModalLoader());
    postRequest(`api/Appointment/AddAppointment`, data)
      .then((res) => {
        var appointmentid = res.data.appointmentId;
        var appointmentNbr = res.data.appointmentNbr;
        dispatch(resetAppointmentstate());
        var empId = localStorage.getItem("employeeId");
        if (empId)
          var obj = {
            staffMemberId: empId,
            pageNumber: 1,
            pageSize: 10,
            searchTerm: "",
            startDate: dayjs().startOf("day").format("YYYY-MM-DDTHH:mm:ssZ"),
            endDate: dayjs().endOf("day").format("YYYY-MM-DDTHH:mm:ssZ"),
          };
        dispatch(
          setRange({
            startDate: dayjs().startOf("day"),
            endDate: dayjs().endOf("day"),
          }),
        );
        dispatch(getAppointListAPI(obj, true)).then((result) => {
          if (result && result.length > 0) {
            if (
              result.find((element) => element.noteID === appointmentid) != null
            ) {
              const appointmentDetails = {
                appointmentNoteId: appointmentid,
                appointmentNbr: appointmentNbr,
              };
              JSON.stringify(appointmentDetails);
              localStorage.setItem(
                "selectedAppointment",
                JSON.stringify(appointmentDetails),
              );
              dispatch(setSelectedAppointment(appointmentid));
              refreshURL(appointmentid);
            } else {
              refreshURL(null);
              dispatch(setSelectedAppointment(null));
            }
            dispatch(setPageNo(2));
          }
        });

        const successMessage = `Successfully added new Appointment App no: ${appointmentNbr}`;
        OpenNotificationWithIcon("success", null, successMessage);
        dispatch(hideModalLoader());
        return true;
      })
      .catch((e) => {
        dispatch(hideModalLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "CreateAppointment.UnableAddNewAppointment",
        );
      });
  } catch (e) {
    dispatch(hideModalLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "CreateAppointment.UnableAddNewAppointment",
    );
  }
};
